/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { BarChartPanel } from "vr-react-components";
import { setDataRightChartSelected } from "../../store/slice/roomSlices/homeSlice";

let placeholderData;

const BarPanelWidget = ({ stateName, currentRoom, ...otherAttributes }) => {
    const canModify = useSelector((state) => state.private.device.canModify);
    const data = useSelector((state) => state[currentRoom][stateName]);

    const dispatch = useDispatch();

    const handleSetSelected = (selected) => {
        if (!placeholderData)
            dispatch(setDataRightChartSelected(selected));
    }

    return (
        <BarChartPanel
            {...otherAttributes}
            data={data}
            setSelected={handleSetSelected}
            aframeClasses={canModify ? "collidable" : ""}
        />
    );
};

export default BarPanelWidget;
